import { Box, ColorOptions, Icon, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { Image } from '@jfs/ui-new/src/comps/ImageNew'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import { FC, useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { BottomSheet } from '../../../comps/BottomSheet'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { isSessionValid } from '../../../util/util'

const Review: FC = (props: any) => {
  const { activateQrCode, userMobile, initialized, resetAccessToken } = useStores((store) => ({
    activateQrCode: store.agentQrUser.activateQrCode,
    userMobile: store.agentQrUser.mobile,
    resetAccessToken: store.agentQrSession.resetAccessToken,
    initialized: store.agentQrSession.initialized,
  }))
  const { route } = props
  const data = route?.params ?? undefined

  const navigation = useNavigation()
  const { height: SCREEN_HEIGHT } = useWindowDimensions()

  const isLandscape = () => window.matchMedia('(orientation:landscape)').matches

  const [activationState, setActivationState] = useState('')
  const [callActivateQrCode, activateQrCodeHandler] = useLazyApiData(activateQrCode)

  const isFocused = useIsFocused()

  useEffect(() => {
    if (activateQrCodeHandler.state === 'fulfilled' && activationState === 'activating') {
      setActivationState('activated')
      const status = activateQrCodeHandler.data.status
      setTimeout(() => {
        setActivationState('')
        navigation.navigate('status', { data: data, status: status })
      }, 2200)
    } else if (activateQrCodeHandler.state === 'rejected') {
      setActivationState('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activateQrCodeHandler.state])

  useEffect(() => {
    if (!initialized && isFocused) {
      if (navigation?.canGoBack()) {
        navigation.goBack()
      } else {
        const csoSessData = window.localStorage.getItem('csoSessData')
        console.log('csoSessData', csoSessData)
        if (csoSessData && csoSessData?.length > 0 && isSessionValid(csoSessData)) {
          navigation.reset({
            index: 0,
            routes: [{ name: Routes.midslist }],
          })
        } else {
          navigation.reset({
            index: 0,
            routes: [{ name: Routes.QrAgentLogin }],
          })
          resetAccessToken()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, navigation, resetAccessToken])

  const onBackPress = () => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: 'midslist',
        },
      ],
    })
  }

  const onActivate = () => {
    setActivationState('activating')
    callActivateQrCode(data?.mid, data?.tid, data?.vpa, userMobile)
  }

  const onClose = () => {
    setActivationState('')
  }

  return (
    <Box bg={'WHITE'} padding={24} f={1}>
      <Box
        bg={'#0186B052' as ColorOptions}
        w={360}
        h={360}
        borderRadius={180}
        position={'absolute'}
        top={-180}
        left={-180}
      />
      <Box
        alignItems={'flex-start'}
        justify={'center'}
        marginTop={36}
        height={20}
        width={25}
        onPress={onBackPress}
        testID="arrow-back"
        underlayColor={'TRANSPARENT45'}
        marginBottom={50}>
        <Image source={require('../../../assets/images/keyboard_backspace.png')} height={20} width={25} />
      </Box>
      <Image source={require('../../../assets/images/reviewLogo.png')} height={68} width={62} />
      <Box marginTop={40}>
        <Text fontFamily="jiotype-black" fontSize={18} color={'BLACK_75'}>
          {'Review merchant details'}
        </Text>
      </Box>
      <Box minHeight={40} marginVertical={16}>
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
          {'MID'}
        </Text>
        <Text fontFamily="jiotype-bold" fontSize={16} color={'BLACK_21'}>
          {data?.mid ?? 'N/A'}
        </Text>
      </Box>
      <Box minHeight={40} marginVertical={16}>
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
          {'Business Name'}
        </Text>
        <Text fontFamily="jiotype-bold" fontSize={16} color={'BLACK_21'} numberOfLines={1} ellipsizeMode="tail">
          {data?.name ?? 'N/A'}
        </Text>
      </Box>
      <Box minHeight={40} marginVertical={16}>
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
          {'Merchant Mobile'}
        </Text>
        <Text fontFamily="jiotype-bold" fontSize={16} color={'BLACK_21'}>
          {data?.mobile ?? 'N/A'}
        </Text>
      </Box>
      <Box minHeight={40} marginVertical={16}>
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
          {'VPA'}
        </Text>
        <Text fontFamily="jiotype-bold" fontSize={16} color={'BLACK_21'}>
          {data?.vpa ?? 'N/A'}
        </Text>
      </Box>
      <Box minHeight={40} marginVertical={16}>
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
          {'TID'}
        </Text>
        <Text fontFamily="jiotype-bold" fontSize={16} color={'BLACK_21'}>
          {data?.tid ?? 'N/A'}
        </Text>
      </Box>
      <Box alignItems={'center'} justifyContent={'flex-end'} paddingHorizontal={24} marginTop={32} marginBottom={32}>
        <Box
          width={'100%'}
          borderRadius={8}
          h={48}
          marginBottom={40}
          bg={'#0070B6' as ColorOptions}
          underlayColor={'PRIMARY_GREY'}
          testID="activate-qr"
          onPress={onActivate}
          alignItems={'center'}
          justifyContent={'center'}
          flexDirection={'row'}>
          <Text title={'Activate QR'} fontFamily={'jiotype-medium'} fontSize={14} color={'WHITE'} />
          <SpacerNew direction={'horizontal'} size={8} />
          <Icon id={'SCAN_QR'} size={24} color={'WHITE'} />
        </Box>
      </Box>
      <ModBox
        position="absolute"
        top={!isLandscape() ? SCREEN_HEIGHT - 300 : SCREEN_HEIGHT}
        left={0}
        w={'100%'}
        show={activationState.length > 0}>
        <BottomSheet status={activationState} onClose={onClose} />
      </ModBox>
    </Box>
  )
}

export { Review as default }
